import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTreeModule } from '@angular/material/tree';

import { LoadingSpinnerComponent } from '../loading-spinner/loading-spinner.component';
import { StructureTreeComponent } from './structure-tree.component';

@NgModule({
    declarations: [
        StructureTreeComponent, //
    ],
    imports: [
        CommonModule, //
        MatTreeModule,
        MatIconModule,
        LoadingSpinnerComponent,
    ],
    exports: [
        StructureTreeComponent, //
    ],
})
export class StructureTreeModule {}
